<template>
  <v-row align="center" justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span>
            Sortition list
          </span>
          <v-btn
            small
            color="primary"
            :to="{ name: $routes.admin.sortitionDisplay.createRoute.name }"
          >
            Create sortition
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :loading="loading"
            :headers="tableColumns"
            :items="sortitions"
          >
            <template v-slot:item.action="{ item }">
              <v-btn icon @click="editSortition(item)">
                <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
              </v-btn>
              <v-btn icon @click="deleteSortition(item)">
                <font-awesome-icon icon="trash"></font-awesome-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <sortition-delete-dialog
      v-model="deleteDialog.show"
      :sortition="deleteDialog.sortition"
      is-for-display
      @delete="handleDelete"
    >
    </sortition-delete-dialog>
  </v-row>
</template>

<script>
import { fetchSortitions } from "@/api/sortitionDisplay.api";
import ContentLoader from "../../../mixins/ContentLoader.js";

export default {
  name: "SortitionIndex",
  components: {
    SortitionDeleteDialog: () =>
      import("../../../components/sortition/SortitionDeleteDialog.vue")
  },
  mixins: [ContentLoader],
  data() {
    return {
      sortitions: [],
      deleteDialog: {
        show: false,
        sortition: {}
      },
      tableColumns: [
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Actions",
          value: "action"
        }
      ]
    };
  },
  async mounted() {
    this.$startLoading();

    try {
      const result = await fetchSortitions(),
        { sortitions } = result.data;

      this.sortitions = sortitions;

      await this.$nextTick();
    } catch (e) {
      console.error(e);
    } finally {
      this.$finishedLoading();
    }
  },
  methods: {
    handleDelete(sortition) {
      this.sortitions.splice(this.sortitions.indexOf(sortition), 1);
    },
    async deleteSortition(item) {
      this.deleteDialog.sortition = item;
      await this.$nextTick();
      this.deleteDialog.show = true;
    },
    editSortition({ id }) {
      this.$router.push({
        name: this.$routes.admin.sortitionDisplay.editRoute.name,
        params: { id }
      });
    }
  }
};
</script>

<style scoped></style>
